// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.register {
  min-height: 100vh;
  background: linear-gradient(135deg, #1D1136, #5734A4);
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.register-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  max-width: 800px;
  width: 100%;
  padding: 0;
  overflow: hidden;
}

.register-header {
  background: linear-gradient(135deg, #031A54, #1a237e);
  color: white;
  padding: 2rem;
  text-align: center;
}

.register-header h1 {
  margin: 0 0 0.5rem 0;
  font-size: 2.5rem;
  font-weight: 700;
}

.register-header p {
  margin: 0;
  font-size: 1.1rem;
  opacity: 0.9;
}

.register-form {
  padding: 2rem;
}

.form-section {
  margin-bottom: 2.5rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #e9ecef;
}

.form-section:last-child {
  border-bottom: none;
  margin-bottom: 2rem;
}

.form-section h3 {
  color: #1e3c72;
  margin: 0 0 1.5rem 0;
  font-size: 1.4rem;
  font-weight: 600;
  border-bottom: 2px solid #1e3c72;
  padding-bottom: 0.5rem;
}

.form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.form-row .form-group {
  flex: 1 1;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #333;
  font-size: 0.95rem;
}

.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background-color: #fff;
}

.form-group input:focus {
  outline: none;
  border-color: #1e3c72;
  box-shadow: 0 0 0 3px rgba(30, 60, 114, 0.1);
}

.form-group input::placeholder {
  color: #adb5bd;
}

.error-message {
  background-color: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 1px solid #f5c6cb;
  font-weight: 500;
}

/* Password Strength Indicator */
.password-strength {
  margin-top: 0.5rem;
}

.strength-bar {
  width: 100%;
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.25rem;
}

.strength-fill {
  height: 100%;
  transition: all 0.3s ease;
}

.strength-text {
  font-size: 0.875rem;
  font-weight: 500;
  color: #495057;
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 2px solid #e9ecef;
}

.form-actions button {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: white;
  border: none;
  padding: 1rem 3rem;
  border-radius: 25px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.3);
  min-width: 200px;
}

.form-actions button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(30, 60, 114, 0.4);
}

.form-actions button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .register {
    padding: 1rem;
  }

  .register-header {
    padding: 1.5rem;
  }

  .register-header h1 {
    font-size: 2rem;
  }

  .register-form {
    padding: 1.5rem;
  }

  .form-row {
    flex-direction: column;
    gap: 0;
  }

  .form-actions button {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .register-header h1 {
    font-size: 1.8rem;
  }

  .form-section h3 {
    font-size: 1.2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Register.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".register {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #1D1136, #5734A4);\n  padding: 2rem 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n.register-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  max-width: 800px;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n\n.register-header {\n  background: linear-gradient(135deg, #031A54, #1a237e);\n  color: white;\n  padding: 2rem;\n  text-align: center;\n}\n\n.register-header h1 {\n  margin: 0 0 0.5rem 0;\n  font-size: 2.5rem;\n  font-weight: 700;\n}\n\n.register-header p {\n  margin: 0;\n  font-size: 1.1rem;\n  opacity: 0.9;\n}\n\n.register-form {\n  padding: 2rem;\n}\n\n.form-section {\n  margin-bottom: 2.5rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.form-section:last-child {\n  border-bottom: none;\n  margin-bottom: 2rem;\n}\n\n.form-section h3 {\n  color: #1e3c72;\n  margin: 0 0 1.5rem 0;\n  font-size: 1.4rem;\n  font-weight: 600;\n  border-bottom: 2px solid #1e3c72;\n  padding-bottom: 0.5rem;\n}\n\n.form-row {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.form-row .form-group {\n  flex: 1;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background-color: #fff;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #1e3c72;\n  box-shadow: 0 0 0 3px rgba(30, 60, 114, 0.1);\n}\n\n.form-group input::placeholder {\n  color: #adb5bd;\n}\n\n.error-message {\n  background-color: #f8d7da;\n  color: #721c24;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border: 1px solid #f5c6cb;\n  font-weight: 500;\n}\n\n/* Password Strength Indicator */\n.password-strength {\n  margin-top: 0.5rem;\n}\n\n.strength-bar {\n  width: 100%;\n  height: 8px;\n  background-color: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 0.25rem;\n}\n\n.strength-fill {\n  height: 100%;\n  transition: all 0.3s ease;\n}\n\n.strength-text {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #495057;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 2px solid #e9ecef;\n}\n\n.form-actions button {\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n  color: white;\n  border: none;\n  padding: 1rem 3rem;\n  border-radius: 25px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(30, 60, 114, 0.3);\n  min-width: 200px;\n}\n\n.form-actions button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(30, 60, 114, 0.4);\n}\n\n.form-actions button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .register {\n    padding: 1rem;\n  }\n\n  .register-header {\n    padding: 1.5rem;\n  }\n\n  .register-header h1 {\n    font-size: 2rem;\n  }\n\n  .register-form {\n    padding: 1.5rem;\n  }\n\n  .form-row {\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .form-actions button {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .register-header h1 {\n    font-size: 1.8rem;\n  }\n\n  .form-section h3 {\n    font-size: 1.2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
